<template>
  <div class="kpt-dashboard-wrapper">
    <vue-headful title="Dashboard" />
    <header class="kpt-dashboard-header level">
      <div class="level-left">
        <div class="level-item">
          <b-select v-model="selectedDashboard" size="is-small">
            <option v-for="(val, idx) in dashboards" :value="val" :key="idx">{{val.name}}</option>
          </b-select>
        </div>
        <div class="level-item">
          <b-button size="is-small" icon-left="plus" @click="addDashboard(false)">Add dashboard</b-button>
        </div>
        <div class="level-item">
          <b-button size="is-small" icon-left="edit">Edit</b-button>
        </div>
        <div class="level-item">
          <b-button size="is-small" icon-left="expand-alt" @click="goFullScreen">Full Screen</b-button>
        </div>
        <div class="level-item">
          <b-button size="is-small" icon-left="trash-alt" @click="deleteDashboard">Delete</b-button>
        </div>
      </div>
    </header>
    <div class="kpt-dashboard-container">
      <div class="resolution-guides">
        <div class="res-1024"></div>
        <div class="res-1366"></div>
        <div class="res-1440"></div>
        <div class="res-1920"></div>
      </div>
      <p>Selected Dashboard: {{selectedDashboard ? selectedDashboard.name : ''}}</p>
      <pre>{{selectedDashboard}}</pre>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      
    }
  },
  computed: {
    selectedDashboard: {
      get() {
        return this.$store.state.dashboard.selectedDashboard;
      },
      set(value) {
        this.$store.dispatch('setLastDashboard', value.id);
        this.$store.commit('setSelectedDashboard', value);
      }
    },
    dashboards() {
      return this.$store.state.dashboard.dashboards;
    },
    widgets() {
      // NYI
      return null;
    }
  },
  created() {
    if (!this.dashboards.length) this.addDashboard(true);
  },
  methods: {
    addDashboard(bypass) {
      if (!bypass) {
        this.$buefy.dialog.prompt({
          title: 'Add Dashboard',
          message: 'What do you want to call this dashboard?',
          inputAttrs: {
            placeholder: 'e.g. Maritime Dashboard',
            maxlength: 255
          },
          onConfirm: value => {
            this.$store.dispatch('addDashboard', value);
          }
        });
      } else {
        this.$store.dispatch('addDashboard', 'My Dashboard');
      }
    },
    deleteDashboard() {
      if (this.dashboards.length == 1) {
        this.$buefy.snackbar.open({
          message: 'You cannot delete your last dashboard',
          type: 'is-warning',
          position: 'is-top',
          actionText: 'OK',
          indefinite: true
        })
        return;
      }
      this.$store.dispatch('deleteDashboard', this.selectedDashboard.id);
    },
    goFullScreen() {
      const elem = document.getElementsByClassName('kpt-dashboard-container');
      if (elem[0].requestFullscreen) {
        // this always exists so we can index into it safely
        elem[0].requestFullscreen();
      } else if (elem[0].webkitRequestFullscreen) {
        elem[0].webkitRequestFullscreen();
      } else {
        alert('Full screen is not supported in your browser.');
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.kpt-dashboard-wrapper {
  display: flex;
  flex-direction: column;
  padding: 15px 25px;

  .kpt-dashboard-header {
    margin-bottom: 15px;
  }
  .kpt-dashboard-container {
    flex: 1 0 auto;
    position: relative;

    &:-webkit-full-screen {
      width: 100%;
      height: 100%;
      padding: 15px;
      background: white;
    }

    .resolution-guides {
      position: absolute;
      z-index: 0;
      top: 0;
      left: 0;

      .res-1024, .res-1366, .res-1440, .res-1920 {
        position: absolute;
        top: 0;
        left: 0;
      }

      .res-1024 {
        width: 1024px;
        height: 768px;
        background-image: url('~@/assets/1024guide.png');
      }
      .res-1366 {
        width: 1366px;
        height: 768px;
        background-image: url('~@/assets/1366guide.png');
      }
      .res-1440 {
        width: 1440px;
        height: 900px;
        background-image: url('~@/assets/1440guide.png');
      }
      .res-1920 {
        width: 1920px;
        height: 1080px;
        background-image: url('~@/assets/1920guide.png');
      }
    }
  }
}
</style>
